export default "__VITE_ASSET__DUYQvAZJ__"